import { render, staticRenderFns } from "./FinanceTabPayouts.vue?vue&type=template&id=271911da&scoped=true"
import script from "./FinanceTabPayouts.vue?vue&type=script&lang=js"
export * from "./FinanceTabPayouts.vue?vue&type=script&lang=js"
import style0 from "./FinanceTabPayouts.vue?vue&type=style&index=0&id=271911da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271911da",
  null
  
)

export default component.exports